export const capitalCoordinates = {
    GS: {
        name: "South Georgia and South Sandwich Islands",
        capital: "King Edward Point",
        latitude: -54.283333,
        longitude: -36.5
    },
    TF: {
        name: "French Southern and Antarctic Lands",
        capital: "Port-aux-FranÃ§ais",
        latitude: -49.35,
        longitude: 70.216667
    },
    US: {
        name: "United States",
        capital: "Washington",
        latitude: -77,
        longitude: 38.883333
    },
    PS: {
        name: "Palestine",
        capital: "Jerusalem",
        latitude: 31.766666666666666,
        longitude: 35.233333
    },
    AX: {
        name: "Aland Islands",
        capital: "Mariehamn",
        latitude: 60.116667,
        longitude: 19.9
    },
    NR: {
        name: "Nauru",
        capital: "Yaren",
        latitude: -0.5477,
        longitude: 166.920867
    },
    MF: {
        name: "Saint Martin",
        capital: "Marigot",
        latitude: 18.0731,
        longitude: -63.0822
    },
    TK: {
        name: "Tokelau",
        capital: "Atafu",
        latitude: -9.166667,
        longitude: -171.833333
    },
    EH: {
        name: "Western Sahara",
        capital: "El-AaiÃºn",
        latitude: 27.153611,
        longitude: -13.203333
    },
    AF: {
        name: "Afghanistan",
        capital: "Kabul",
        latitude: 34.516666666666666,
        longitude: 69.183333
    },
    AL: {
        name: "Albania",
        capital: "Tirana",
        latitude: 41.31666666666667,
        longitude: 19.816667
    },
    DZ: {
        name: "Algeria",
        capital: "Algiers",
        latitude: 36.75,
        longitude: 3.05
    },
    AS: {
        name: "American Samoa",
        capital: "Pago Pago",
        latitude: -14.266666666666667,
        longitude: -170.7
    },
    AD: {
        name: "Andorra",
        capital: "Andorra la Vella",
        latitude: 42.5,
        longitude: 1.516667
    },
    AO: {
        name: "Angola",
        capital: "Luanda",
        latitude: -8.833333333333334,
        longitude: 13.216667
    },
    AI: {
        name: "Anguilla",
        capital: "The Valley",
        latitude: 18.216666666666665,
        longitude: -63.05
    },
    AG: {
        name: "Antigua and Barbuda",
        capital: "Saint John's",
        latitude: 17.116666666666667,
        longitude: -61.85
    },
    AR: {
        name: "Argentina",
        capital: "Buenos Aires",
        latitude: -34.583333333333336,
        longitude: -58.666667
    },
    AM: {
        name: "Armenia",
        capital: "Yerevan",
        latitude: 40.166666666666664,
        longitude: 44.5
    },
    AW: {
        name: "Aruba",
        capital: "Oranjestad",
        latitude: 12.516666666666667,
        longitude: -70.033333
    },
    AU: {
        name: "Australia",
        capital: "Canberra",
        latitude: -35.266666666666666,
        longitude: 149.133333
    },
    AT: {
        name: "Austria",
        capital: "Vienna",
        latitude: 48.2,
        longitude: 16.366667
    },
    AZ: {
        name: "Azerbaijan",
        capital: "Baku",
        latitude: 40.38333333333333,
        longitude: 49.866667
    },
    BS: {
        name: "Bahamas",
        capital: "Nassau",
        latitude: 25.083333333333332,
        longitude: -77.35
    },
    BH: {
        name: "Bahrain",
        capital: "Manama",
        latitude: 26.233333333333334,
        longitude: 50.566667
    },
    BD: {
        name: "Bangladesh",
        capital: "Dhaka",
        latitude: 23.716666666666665,
        longitude: 90.4
    },
    BB: {
        name: "Barbados",
        capital: "Bridgetown",
        latitude: 13.1,
        longitude: -59.616667
    },
    BY: {
        name: "Belarus",
        capital: "Minsk",
        latitude: 53.9,
        longitude: 27.566667
    },
    BE: {
        name: "Belgium",
        capital: "Brussels",
        latitude: 50.833333333333336,
        longitude: 4.333333
    },
    BZ: {
        name: "Belize",
        capital: "Belmopan",
        latitude: 17.25,
        longitude: -88.766667
    },
    BJ: {
        name: "Benin",
        capital: "Porto-Novo",
        latitude: 6.483333333333333,
        longitude: 2.616667
    },
    BM: {
        name: "Bermuda",
        capital: "Hamilton",
        latitude: 32.28333333333333,
        longitude: -64.783333
    },
    BT: {
        name: "Bhutan",
        capital: "Thimphu",
        latitude: 27.466666666666665,
        longitude: 89.633333
    },
    BO: {
        name: "Bolivia",
        capital: "La Paz",
        latitude: -16.5,
        longitude: -68.15
    },
    BA: {
        name: "Bosnia and Herzegovina",
        capital: "Sarajevo",
        latitude: 43.86666666666667,
        longitude: 18.416667
    },
    BW: {
        name: "Botswana",
        capital: "Gaborone",
        latitude: -24.633333333333333,
        longitude: 25.9
    },
    BR: {
        name: "Brazil",
        capital: "Brasilia",
        latitude: -15.783333333333333,
        longitude: -47.916667
    },
    VG: {
        name: "British Virgin Islands",
        capital: "Road Town",
        latitude: 18.416666666666668,
        longitude: -64.616667
    },
    BN: {
        name: "Brunei Darussalam",
        capital: "Bandar Seri Begawan",
        latitude: 4.883333333333333,
        longitude: 114.933333
    },
    BG: {
        name: "Bulgaria",
        capital: "Sofia",
        latitude: 42.68333333333333,
        longitude: 23.316667
    },
    BF: {
        name: "Burkina Faso",
        capital: "Ouagadougou",
        latitude: 12.366666666666667,
        longitude: -1.516667
    },
    MM: {
        name: "Myanmar",
        capital: "Rangoon",
        latitude: 16.8,
        longitude: 96.15
    },
    BI: {
        name: "Burundi",
        capital: "Bujumbura",
        latitude: -3.3666666666666667,
        longitude: 29.35
    },
    KH: {
        name: "Cambodia",
        capital: "Phnom Penh",
        latitude: 11.55,
        longitude: 104.916667
    },
    CM: {
        name: "Cameroon",
        capital: "Yaounde",
        latitude: 3.8666666666666667,
        longitude: 11.516667
    },
    CA: {
        name: "Canada",
        capital: "Ottawa",
        latitude: 45.416666666666664,
        longitude: -75.7
    },
    CV: {
        name: "Cape Verde",
        capital: "Praia",
        latitude: 14.916666666666666,
        longitude: -23.516667
    },
    KY: {
        name: "Cayman Islands",
        capital: "George Town",
        latitude: 19.3,
        longitude: -81.383333
    },
    CF: {
        name: "Central African Republic",
        capital: "Bangui",
        latitude: 4.366666666666666,
        longitude: 18.583333
    },
    TD: {
        name: "Chad",
        capital: "N'Djamena",
        latitude: 12.1,
        longitude: 15.033333
    },
    CL: {
        name: "Chile",
        capital: "Santiago",
        latitude: -33.45,
        longitude: -70.666667
    },
    CN: {
        name: "China",
        capital: "Beijing",
        latitude: 39.916666666666664,
        longitude: 116.383333
    },
    CX: {
        name: "Christmas Island",
        capital: "The Settlement",
        latitude: -10.416666666666666,
        longitude: 105.716667
    },
    CC: {
        name: "Cocos Islands",
        capital: "West Island",
        latitude: -12.166666666666666,
        longitude: 96.833333
    },
    CO: {
        name: "Colombia",
        capital: "Bogota",
        latitude: 4.6,
        longitude: -74.083333
    },
    KM: {
        name: "Comoros",
        capital: "Moroni",
        latitude: -11.7,
        longitude: 43.233333
    },
    CD: {
        name: "Democratic Republic of the Congo",
        capital: "Kinshasa",
        latitude: -4.316666666666666,
        longitude: 15.3
    },
    CG: {
        name: "Republic of Congo",
        capital: "Brazzaville",
        latitude: -4.25,
        longitude: 15.283333
    },
    CK: {
        name: "Cook Islands",
        capital: "Avarua",
        latitude: -21.2,
        longitude: -159.766667
    },
    CR: {
        name: "Costa Rica",
        capital: "San Jose",
        latitude: 9.933333333333334,
        longitude: -84.083333
    },
    CI: {
        name: "Cote d'Ivoire",
        capital: "Yamoussoukro",
        latitude: 6.816666666666666,
        longitude: -5.266667
    },
    HR: {
        name: "Croatia",
        capital: "Zagreb",
        latitude: 45.8,
        longitude: 16
    },
    CU: {
        name: "Cuba",
        capital: "Havana",
        latitude: 23.116666666666667,
        longitude: -82.35
    },
    CW: {
        name: "CuraÃ§ao",
        capital: "Willemstad",
        latitude: 12.1,
        longitude: -68.916667
    },
    CY: {
        name: "Cyprus",
        capital: "Nicosia",
        latitude: 35.166666666666664,
        longitude: 33.366667
    },
    CZ: {
        name: "Czech Republic",
        capital: "Prague",
        latitude: 50.083333333333336,
        longitude: 14.466667
    },
    DK: {
        name: "Denmark",
        capital: "Copenhagen",
        latitude: 55.666666666666664,
        longitude: 12.583333
    },
    DJ: {
        name: "Djibouti",
        capital: "Djibouti",
        latitude: 11.583333333333334,
        longitude: 43.15
    },
    DM: {
        name: "Dominica",
        capital: "Roseau",
        latitude: 15.3,
        longitude: -61.4
    },
    DO: {
        name: "Dominican Republic",
        capital: "Santo Domingo",
        latitude: 18.466666666666665,
        longitude: -69.9
    },
    EC: {
        name: "Ecuador",
        capital: "Quito",
        latitude: -0.21666666666666667,
        longitude: -78.5
    },
    EG: {
        name: "Egypt",
        capital: "Cairo",
        latitude: 30.05,
        longitude: 31.25
    },
    SV: {
        name: "El Salvador",
        capital: "San Salvador",
        latitude: 13.7,
        longitude: -89.2
    },
    GQ: {
        name: "Equatorial Guinea",
        capital: "Malabo",
        latitude: 3.75,
        longitude: 8.783333
    },
    ER: {
        name: "Eritrea",
        capital: "Asmara",
        latitude: 15.333333333333334,
        longitude: 38.933333
    },
    EE: {
        name: "Estonia",
        capital: "Tallinn",
        latitude: 59.43333333333333,
        longitude: 24.716667
    },
    ET: {
        name: "Ethiopia",
        capital: "Addis Ababa",
        latitude: 9.033333333333333,
        longitude: 38.7
    },
    FK: {
        name: "Falkland Islands",
        capital: "Stanley",
        latitude: -51.7,
        longitude: -57.85
    },
    FO: {
        name: "Faroe Islands",
        capital: "Torshavn",
        latitude: 62,
        longitude: -6.766667
    },
    FJ: {
        name: "Fiji",
        capital: "Suva",
        latitude: -18.133333333333333,
        longitude: 178.416667
    },
    FI: {
        name: "Finland",
        capital: "Helsinki",
        latitude: 60.166666666666664,
        longitude: 24.933333
    },
    FR: {
        name: "France",
        capital: "Paris",
        latitude: 48.86666666666667,
        longitude: 2.333333
    },
    PF: {
        name: "French Polynesia",
        capital: "Papeete",
        latitude: -17.533333333333335,
        longitude: -149.566667
    },
    GA: {
        name: "Gabon",
        capital: "Libreville",
        latitude: 0.38333333333333336,
        longitude: 9.45
    },
    GM: {
        name: "The Gambia",
        capital: "Banjul",
        latitude: 13.45,
        longitude: -16.566667
    },
    GE: {
        name: "Georgia",
        capital: "Tbilisi",
        latitude: 41.68333333333333,
        longitude: 44.833333
    },
    DE: {
        name: "Germany",
        capital: "Berlin",
        latitude: 52.516666666666666,
        longitude: 13.4
    },
    GH: {
        name: "Ghana",
        capital: "Accra",
        latitude: 5.55,
        longitude: -0.216667
    },
    GI: {
        name: "Gibraltar",
        capital: "Gibraltar",
        latitude: 36.13333333333333,
        longitude: -5.35
    },
    GR: {
        name: "Greece",
        capital: "Athens",
        latitude: 37.983333333333334,
        longitude: 23.733333
    },
    GL: {
        name: "Greenland",
        capital: "Nuuk",
        latitude: 64.18333333333334,
        longitude: -51.75
    },
    GD: {
        name: "Grenada",
        capital: "Saint George's",
        latitude: 12.05,
        longitude: -61.75
    },
    GU: {
        name: "Guam",
        capital: "Hagatna",
        latitude: 13.466666666666667,
        longitude: 144.733333
    },
    GT: {
        name: "Guatemala",
        capital: "Guatemala City",
        latitude: 14.616666666666667,
        longitude: -90.516667
    },
    GG: {
        name: "Guernsey",
        capital: "Saint Peter Port",
        latitude: 49.45,
        longitude: -2.533333
    },
    GN: {
        name: "Guinea",
        capital: "Conakry",
        latitude: 9.5,
        longitude: -13.7
    },
    GW: {
        name: "Guinea-Bissau",
        capital: "Bissau",
        latitude: 11.85,
        longitude: -15.583333
    },
    GY: {
        name: "Guyana",
        capital: "Georgetown",
        latitude: 6.8,
        longitude: -58.15
    },
    HT: {
        name: "Haiti",
        capital: "Port-au-Prince",
        latitude: 18.533333333333335,
        longitude: -72.333333
    },
    VA: {
        name: "Vatican City",
        capital: "Vatican City",
        latitude: 41.9,
        longitude: 12.45
    },
    HN: {
        name: "Honduras",
        capital: "Tegucigalpa",
        latitude: 14.1,
        longitude: -87.216667
    },
    HU: {
        name: "Hungary",
        capital: "Budapest",
        latitude: 47.5,
        longitude: 19.083333
    },
    IS: {
        name: "Iceland",
        capital: "Reykjavik",
        latitude: 64.15,
        longitude: -21.95
    },
    IN: {
        name: "India",
        capital: "New Delhi",
        latitude: 28.6,
        longitude: 77.2
    },
    ID: {
        name: "Indonesia",
        capital: "Jakarta",
        latitude: -6.166666666666667,
        longitude: 106.816667
    },
    IR: {
        name: "Iran",
        capital: "Tehran",
        latitude: 35.7,
        longitude: 51.416667
    },
    IQ: {
        name: "Iraq",
        capital: "Baghdad",
        latitude: 33.333333333333336,
        longitude: 44.4
    },
    IE: {
        name: "Ireland",
        capital: "Dublin",
        latitude: 53.31666666666667,
        longitude: -6.233333
    },
    IM: {
        name: "Isle of Man",
        capital: "Douglas",
        latitude: 54.15,
        longitude: -4.483333
    },
    IL: {
        name: "Israel",
        capital: "Jerusalem",
        latitude: 31.766666666666666,
        longitude: 35.233333
    },
    IT: {
        name: "Italy",
        capital: "Rome",
        latitude: 41.9,
        longitude: 12.483333
    },
    JM: {
        name: "Jamaica",
        capital: "Kingston",
        latitude: 18,
        longitude: -76.8
    },
    JP: {
        name: "Japan",
        capital: "Tokyo",
        latitude: 35.68333333333333,
        longitude: 139.75
    },
    JE: {
        name: "Jersey",
        capital: "Saint Helier",
        latitude: 49.18333333333333,
        longitude: -2.1
    },
    JO: {
        name: "Jordan",
        capital: "Amman",
        latitude: 31.95,
        longitude: 35.933333
    },
    KZ: {
        name: "Kazakhstan",
        capital: "Astana",
        latitude: 51.166666666666664,
        longitude: 71.416667
    },
    KE: {
        name: "Kenya",
        capital: "Nairobi",
        latitude: -1.2833333333333332,
        longitude: 36.816667
    },
    KI: {
        name: "Kiribati",
        capital: "Tarawa",
        latitude: -0.8833333333333333,
        longitude: 169.533333
    },
    KP: {
        name: "North Korea",
        capital: "Pyongyang",
        latitude: 39.016666666666666,
        longitude: 125.75
    },
    KR: {
        name: "South Korea",
        capital: "Seoul",
        latitude: 37.55,
        longitude: 126.983333
    },
    KO: {
        name: "Kosovo",
        capital: "Pristina",
        latitude: 42.666666666666664,
        longitude: 21.166667
    },
    KW: {
        name: "Kuwait",
        capital: "Kuwait City",
        latitude: 29.366666666666667,
        longitude: 47.966667
    },
    KG: {
        name: "Kyrgyzstan",
        capital: "Bishkek",
        latitude: 42.86666666666667,
        longitude: 74.6
    },
    LA: {
        name: "Laos",
        capital: "Vientiane",
        latitude: 17.966666666666665,
        longitude: 102.6
    },
    LV: {
        name: "Latvia",
        capital: "Riga",
        latitude: 56.95,
        longitude: 24.1
    },
    LB: {
        name: "Lebanon",
        capital: "Beirut",
        latitude: 33.86666666666667,
        longitude: 35.5
    },
    LS: {
        name: "Lesotho",
        capital: "Maseru",
        latitude: -29.316666666666666,
        longitude: 27.483333
    },
    LR: {
        name: "Liberia",
        capital: "Monrovia",
        latitude: 6.3,
        longitude: -10.8
    },
    LY: {
        name: "Libya",
        capital: "Tripoli",
        latitude: 32.88333333333333,
        longitude: 13.166667
    },
    LI: {
        name: "Liechtenstein",
        capital: "Vaduz",
        latitude: 47.13333333333333,
        longitude: 9.516667
    },
    LT: {
        name: "Lithuania",
        capital: "Vilnius",
        latitude: 54.68333333333333,
        longitude: 25.316667
    },
    LU: {
        name: "Luxembourg",
        capital: "Luxembourg",
        latitude: 49.6,
        longitude: 6.116667
    },
    MK: {
        name: "Macedonia",
        capital: "Skopje",
        latitude: 42,
        longitude: 21.433333
    },
    MG: {
        name: "Madagascar",
        capital: "Antananarivo",
        latitude: -18.916666666666668,
        longitude: 47.516667
    },
    MW: {
        name: "Malawi",
        capital: "Lilongwe",
        latitude: -13.966666666666667,
        longitude: 33.783333
    },
    MY: {
        name: "Malaysia",
        capital: "Kuala Lumpur",
        latitude: 3.1666666666666665,
        longitude: 101.7
    },
    MV: {
        name: "Maldives",
        capital: "Male",
        latitude: 4.166666666666667,
        longitude: 73.5
    },
    ML: {
        name: "Mali",
        capital: "Bamako",
        latitude: 12.65,
        longitude: -8
    },
    MT: {
        name: "Malta",
        capital: "Valletta",
        latitude: 35.88333333333333,
        longitude: 14.5
    },
    MH: {
        name: "Marshall Islands",
        capital: "Majuro",
        latitude: 7.1,
        longitude: 171.383333
    },
    MR: {
        name: "Mauritania",
        capital: "Nouakchott",
        latitude: 18.066666666666666,
        longitude: -15.966667
    },
    MU: {
        name: "Mauritius",
        capital: "Port Louis",
        latitude: -20.15,
        longitude: 57.483333
    },
    MX: {
        name: "Mexico",
        capital: "Mexico City",
        latitude: 19.433333333333334,
        longitude: -99.133333
    },
    FM: {
        name: "Federated States of Micronesia",
        capital: "Palikir",
        latitude: 6.916666666666667,
        longitude: 158.15
    },
    MD: {
        name: "Moldova",
        capital: "Chisinau",
        latitude: 47,
        longitude: 28.85
    },
    MC: {
        name: "Monaco",
        capital: "Monaco",
        latitude: 43.733333333333334,
        longitude: 7.416667
    },
    MN: {
        name: "Mongolia",
        capital: "Ulaanbaatar",
        latitude: 47.916666666666664,
        longitude: 106.916667
    },
    ME: {
        name: "Montenegro",
        capital: "Podgorica",
        latitude: 42.43333333333333,
        longitude: 19.266667
    },
    MS: {
        name: "Montserrat",
        capital: "Plymouth",
        latitude: 16.7,
        longitude: -62.216667
    },
    MA: {
        name: "Morocco",
        capital: "Rabat",
        latitude: 34.016666666666666,
        longitude: -6.816667
    },
    MZ: {
        name: "Mozambique",
        capital: "Maputo",
        latitude: -25.95,
        longitude: 32.583333
    },
    NA: {
        name: "Namibia",
        capital: "Windhoek",
        latitude: -22.566666666666666,
        longitude: 17.083333
    },
    NP: {
        name: "Nepal",
        capital: "Kathmandu",
        latitude: 27.716666666666665,
        longitude: 85.316667
    },
    NL: {
        name: "Netherlands",
        capital: "Amsterdam",
        latitude: 52.35,
        longitude: 4.916667
    },
    NC: {
        name: "New Caledonia",
        capital: "Noumea",
        latitude: -22.266666666666666,
        longitude: 166.45
    },
    NZ: {
        name: "New Zealand",
        capital: "Wellington",
        latitude: -41.3,
        longitude: 174.783333
    },
    NI: {
        name: "Nicaragua",
        capital: "Managua",
        latitude: 12.133333333333333,
        longitude: -86.25
    },
    NE: {
        name: "Niger",
        capital: "Niamey",
        latitude: 13.516666666666667,
        longitude: 2.116667
    },
    NG: {
        name: "Nigeria",
        capital: "Abuja",
        latitude: 9.083333333333334,
        longitude: 7.533333
    },
    NU: {
        name: "Niue",
        capital: "Alofi",
        latitude: -19.016666666666666,
        longitude: -169.916667
    },
    NF: {
        name: "Norfolk Island",
        capital: "Kingston",
        latitude: -29.05,
        longitude: 167.966667
    },
    MP: {
        name: "Northern Mariana Islands",
        capital: "Saipan",
        latitude: 15.2,
        longitude: 145.75
    },
    NO: {
        name: "Norway",
        capital: "Oslo",
        latitude: 59.916666666666664,
        longitude: 10.75
    },
    OM: {
        name: "Oman",
        capital: "Muscat",
        latitude: 23.616666666666667,
        longitude: 58.583333
    },
    PK: {
        name: "Pakistan",
        capital: "Islamabad",
        latitude: 33.68333333333333,
        longitude: 73.05
    },
    PW: {
        name: "Palau",
        capital: "Melekeok",
        latitude: 7.483333333333333,
        longitude: 134.633333
    },
    PA: {
        name: "Panama",
        capital: "Panama City",
        latitude: 8.966666666666667,
        longitude: -79.533333
    },
    PG: {
        name: "Papua New Guinea",
        capital: "Port Moresby",
        latitude: -9.45,
        longitude: 147.183333
    },
    PY: {
        name: "Paraguay",
        capital: "Asuncion",
        latitude: -25.266666666666666,
        longitude: -57.666667
    },
    PE: {
        name: "Peru",
        capital: "Lima",
        latitude: -12.05,
        longitude: -77.05
    },
    PH: {
        name: "Philippines",
        capital: "Manila",
        latitude: 14.6,
        longitude: 120.966667
    },
    PN: {
        name: "Pitcairn Islands",
        capital: "Adamstown",
        latitude: -25.066666666666666,
        longitude: -130.083333
    },
    PL: {
        name: "Poland",
        capital: "Warsaw",
        latitude: 52.25,
        longitude: 21
    },
    PT: {
        name: "Portugal",
        capital: "Lisbon",
        latitude: 38.71666666666667,
        longitude: -9.133333
    },
    PR: {
        name: "Puerto Rico",
        capital: "San Juan",
        latitude: 18.466666666666665,
        longitude: -66.116667
    },
    QA: {
        name: "Qatar",
        capital: "Doha",
        latitude: 25.283333333333335,
        longitude: 51.533333
    },
    RO: {
        name: "Romania",
        capital: "Bucharest",
        latitude: 44.43333333333333,
        longitude: 26.1
    },
    RU: {
        name: "Russia",
        capital: "Moscow",
        latitude: 55.75,
        longitude: 37.6
    },
    RW: {
        name: "Rwanda",
        capital: "Kigali",
        latitude: -1.95,
        longitude: 30.05
    },
    BL: {
        name: "Saint Barthelemy",
        capital: "Gustavia",
        latitude: 17.883333333333333,
        longitude: -62.85
    },
    SH: {
        name: "Saint Helena",
        capital: "Jamestown",
        latitude: -15.933333333333334,
        longitude: -5.716667
    },
    KN: {
        name: "Saint Kitts and Nevis",
        capital: "Basseterre",
        latitude: 17.3,
        longitude: -62.716667
    },
    LC: {
        name: "Saint Lucia",
        capital: "Castries",
        latitude: 14,
        longitude: -61
    },
    PM: {
        name: "Saint Pierre and Miquelon",
        capital: "Saint-Pierre",
        latitude: 46.766666666666666,
        longitude: -56.183333
    },
    VC: {
        name: "Saint Vincent and the Grenadines",
        capital: "Kingstown",
        latitude: 13.133333333333333,
        longitude: -61.216667
    },
    WS: {
        name: "Samoa",
        capital: "Apia",
        latitude: -13.816666666666666,
        longitude: -171.766667
    },
    SM: {
        name: "San Marino",
        capital: "San Marino",
        latitude: 43.93333333333333,
        longitude: 12.416667
    },
    ST: {
        name: "Sao Tome and Principe",
        capital: "Sao Tome",
        latitude: 0.3333333333333333,
        longitude: 6.733333
    },
    SA: {
        name: "Saudi Arabia",
        capital: "Riyadh",
        latitude: 24.65,
        longitude: 46.7
    },
    SN: {
        name: "Senegal",
        capital: "Dakar",
        latitude: 14.733333333333333,
        longitude: -17.633333
    },
    RS: {
        name: "Serbia",
        capital: "Belgrade",
        latitude: 44.833333333333336,
        longitude: 20.5
    },
    SC: {
        name: "Seychelles",
        capital: "Victoria",
        latitude: -4.616666666666667,
        longitude: 55.45
    },
    SL: {
        name: "Sierra Leone",
        capital: "Freetown",
        latitude: 8.483333333333333,
        longitude: -13.233333
    },
    SG: {
        name: "Singapore",
        capital: "Singapore",
        latitude: 1.2833333333333332,
        longitude: 103.85
    },
    SX: {
        name: "Sint Maarten",
        capital: "Philipsburg",
        latitude: 18.016666666666666,
        longitude: -63.033333
    },
    SK: {
        name: "Slovakia",
        capital: "Bratislava",
        latitude: 48.15,
        longitude: 17.116667
    },
    SI: {
        name: "Slovenia",
        capital: "Ljubljana",
        latitude: 46.05,
        longitude: 14.516667
    },
    SB: {
        name: "Solomon Islands",
        capital: "Honiara",
        latitude: -9.433333333333334,
        longitude: 159.95
    },
    SO: {
        name: "Somalia",
        capital: "Mogadishu",
        latitude: 2.066666666666667,
        longitude: 45.333333
    },
    ZA: {
        name: "South Africa",
        capital: "Pretoria",
        latitude: -25.7,
        longitude: 28.216667
    },
    SS: {
        name: "South Sudan",
        capital: "Juba",
        latitude: 4.85,
        longitude: 31.616667
    },
    ES: {
        name: "Spain",
        capital: "Madrid",
        latitude: 40.4,
        longitude: -3.683333
    },
    LK: {
        name: "Sri Lanka",
        capital: "Colombo",
        latitude: 6.916666666666667,
        longitude: 79.833333
    },
    SD: {
        name: "Sudan",
        capital: "Khartoum",
        latitude: 15.6,
        longitude: 32.533333
    },
    SR: {
        name: "Suriname",
        capital: "Paramaribo",
        latitude: 5.833333333333333,
        longitude: -55.166667
    },
    SJ: {
        name: "Svalbard",
        capital: "Longyearbyen",
        latitude: 78.21666666666667,
        longitude: 15.633333
    },
    SZ: {
        name: "Swaziland",
        capital: "Mbabane",
        latitude: -26.316666666666666,
        longitude: 31.133333
    },
    SE: {
        name: "Sweden",
        capital: "Stockholm",
        latitude: 59.333333333333336,
        longitude: 18.05
    },
    CH: {
        name: "Switzerland",
        capital: "Bern",
        latitude: 46.916666666666664,
        longitude: 7.466667
    },
    SY: {
        name: "Syria",
        capital: "Damascus",
        latitude: 33.5,
        longitude: 36.3
    },
    TW: {
        name: "Taiwan",
        capital: "Taipei",
        latitude: 25.033333333333335,
        longitude: 121.516667
    },
    TJ: {
        name: "Tajikistan",
        capital: "Dushanbe",
        latitude: 38.55,
        longitude: 68.766667
    },
    TZ: {
        name: "Tanzania",
        capital: "Dar es Salaam",
        latitude: -6.8,
        longitude: 39.283333
    },
    TH: {
        name: "Thailand",
        capital: "Bangkok",
        latitude: 13.75,
        longitude: 100.516667
    },
    TL: {
        name: "Timor-Leste",
        capital: "Dili",
        latitude: -8.583333333333334,
        longitude: 125.6
    },
    TG: {
        name: "Togo",
        capital: "Lome",
        latitude: 6.116666666666666,
        longitude: 1.216667
    },
    TO: {
        name: "Tonga",
        capital: "Nuku'alofa",
        latitude: -21.133333333333333,
        longitude: -175.2
    },
    TT: {
        name: "Trinidad and Tobago",
        capital: "Port of Spain",
        latitude: 10.65,
        longitude: -61.516667
    },
    TN: {
        name: "Tunisia",
        capital: "Tunis",
        latitude: 36.8,
        longitude: 10.183333
    },
    TR: {
        name: "Turkey",
        capital: "Ankara",
        latitude: 39.93333333333333,
        longitude: 32.866667
    },
    TM: {
        name: "Turkmenistan",
        capital: "Ashgabat",
        latitude: 37.95,
        longitude: 58.383333
    },
    TC: {
        name: "Turks and Caicos Islands",
        capital: "Grand Turk",
        latitude: 21.466666666666665,
        longitude: -71.133333
    },
    TV: {
        name: "Tuvalu",
        capital: "Funafuti",
        latitude: -8.516666666666667,
        longitude: 179.216667
    },
    UG: {
        name: "Uganda",
        capital: "Kampala",
        latitude: 0.31666666666666665,
        longitude: 32.55
    },
    UA: {
        name: "Ukraine",
        capital: "Kyiv",
        latitude: 50.43333333333333,
        longitude: 30.516667
    },
    AE: {
        name: "United Arab Emirates",
        capital: "Abu Dhabi",
        latitude: 24.466666666666665,
        longitude: 54.366667
    },
    GB: {
        name: "United Kingdom",
        capital: "London",
        latitude: 51.5,
        longitude: -0.083333
    },
    UY: {
        name: "Uruguay",
        capital: "Montevideo",
        latitude: -34.85,
        longitude: -56.166667
    },
    UZ: {
        name: "Uzbekistan",
        capital: "Tashkent",
        latitude: 41.31666666666667,
        longitude: 69.25
    },
    VU: {
        name: "Vanuatu",
        capital: "Port-Vila",
        latitude: -17.733333333333334,
        longitude: 168.316667
    },
    VE: {
        name: "Venezuela",
        capital: "Caracas",
        latitude: 10.483333333333333,
        longitude: -66.866667
    },
    VN: {
        name: "Vietnam",
        capital: "Hanoi",
        latitude: 21.033333333333335,
        longitude: 105.85
    },
    VI: {
        name: "US Virgin Islands",
        capital: "Charlotte Amalie",
        latitude: 18.35,
        longitude: -64.933333
    },
    WF: {
        name: "Wallis and Futuna",
        capital: "Mata-Utu",
        latitude: -13.95,
        longitude: -171.933333
    },
    YE: {
        name: "Yemen",
        capital: "Sanaa",
        latitude: 15.35,
        longitude: 44.2
    },
    ZM: {
        name: "Zambia",
        capital: "Lusaka",
        latitude: -15.416666666666666,
        longitude: 28.283333
    },
    ZW: {
        name: "Zimbabwe",
        capital: "Harare",
        latitude: -17.816666666666666,
        longitude: 31.033333
    },
    IO: {
        name: "British Indian Ocean Territory",
        capital: "Diego Garcia",
        latitude: -7.3,
        longitude: 72.4
    }
};